(ns ductile.clerk.sci-env-ext
  (:require-macros [nextjournal.clerk.render.macros :refer [sci-copy-nss]])
  (:require ;; requires without an alias here are there so we can copy them to sci
   ["@codemirror/autocomplete" :as codemirror-autocomplete]
   [clojure+.walk]
   [ductile.clerk.render]
   [ductile.clerk.viewer :refer [dev?]]
   [ductile.time.format]
   [ductile.ui]
   [ductile.ui.announcements]
   [ductile.ui.billing]
   [ductile.ui.components]
   [ductile.ui.compound]
   [ductile.ui.contract]
   [ductile.ui.deframe]
   [ductile.ui.edi]
   [ductile.ui.fahrzeug]
   [ductile.ui.http]
   [ductile.ui.load-builder]
   [ductile.ui.locale]
   [ductile.ui.mobile]
   [ductile.ui.pred-view]
   [ductile.ui.routes]
   [ductile.ui.service-list]
   [ductile.ui.transport]
   [ductile.ui.vehicle-search]
   [ductile.ui.workflow]
   [ductile.uis]
   [ductile.util]
   [ductile.workflow.form-recorder]
   [malli.core]
   [nextjournal.clerk.sci-env]
   [nextjournal.clojure-mode.node]
   [nextjournal.commands.command-bar]
   [nextjournal.leaflet]
   [reagent.core]
   [reitit.frontend.easy]
   [reitit.frontend.history]
   [sci.core :as sci]
   [sci.ctx-store]))

(sci.ctx-store/swap-ctx!
 sci/merge-opts
 {:namespaces
  (-> (sci-copy-nss 'clojure+.walk
                    'ductile.ui
                    'ductile.ui.announcements
                    'ductile.ui.billing
                    'ductile.ui.contract
                    'ductile.ui.edi
                    'ductile.ui.components
                    'ductile.uis
                    'ductile.ui.deframe
                    'ductile.ui.fahrzeug
                    'ductile.ui.mobile
                    'ductile.ui.load-builder
                    'ductile.ui.locale
                    'ductile.ui.icons
                    'ductile.ui.http
                    'ductile.ui.pred-view
                    'ductile.ui.routes
                    'ductile.ui.vehicle-search
                    'ductile.ui.transport
                    'ductile.workflow.form-recorder
                    'ductile.ui.workflow
                    'ductile.clerk.render
                    'ductile.util
                    'sci.core
                    'ductile.ui.compound
                    'ductile.ui.service-list
                    'ductile.time.format
                    'malli.core
                    'nextjournal.leaflet
                    'nextjournal.clojure-mode.node
                    'reitit.frontend.history
                    'reitit.frontend.easy
                    'nextjournal.commands.command-bar)
      (assoc-in ['ductile.clerk.viewer 'dev?] dev?))})

(sci/add-class! (sci.ctx-store/get-ctx)
                'codemirror.autocomplete
                codemirror-autocomplete)

(defn ^:export eval-sci
  "For debugging in the browser console"
  [s]
  (sci/eval-string* (sci.ctx-store/get-ctx) s))
